<template>
  <button
    @click.stop="onClick"
    class="edit-btn"
  >
    <Pen :iconColor="'#0F1C70'" />
  </button>
</template>

<script>
import Pen from '@/components/Icons/FilledCirclePen';
export default {
  name: 'edit-button',
  components: { Pen },
  props: { onClick: Function },
};
</script>

<style lang="scss" scoped>
.edit-btn {
  width: 40px;
  height: 40px;
  line-height: 48px;
  background-color: transparent;
  opacity: 0.4;
  border-radius: 50%;
  border: none;
  color: white;
  padding: 0;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.editmode .edit-btn,
.edit-btn:hover,
.edit-btn:focus {
  opacity: 1;
  background-color: #e2e4f4;
}

.parent-hover {
  opacity: 1;
  background-color: #e2e4f4;
}
</style>
